import { useSnackbar } from '@/hooks/useSnackbar';
import DOMPurify from 'dompurify';

export const HTMLHigienizadoTag = ({ html }: { html: string }) => {
  return (
    <div
      style={{
        all: 'unset',
        display: 'block',
        color: 'inherit',
        fontFamily: 'inherit',
        fontSize: 'inherit',
        lineHeight: 'inherit',
        textAlign: 'inherit',
        overflowWrap: 'break-word',
        wordBreak: 'break-word',
        maxWidth: '100%',
        boxSizing: 'border-box',
        overflow: 'hidden',
      }}
      dangerouslySetInnerHTML={{
        __html: html,
      }}
    />
  );
};

export default function useMetodosUteis() {
  const { mostrarSnackbar } = useSnackbar();

  function copiarCodigoParaAreaDeTransferencia(codigo: string) {
    navigator?.clipboard?.writeText(codigo);
    mostrarSnackbar({
      color: 'success',
      highContrast: true,
      mensagem: 'Código copiado com sucesso!',
      size: 1,
      variant: 'solid',
    });
  }

  function higienizarHTML(html: string): string {
    return DOMPurify.sanitize(html, {
      ALLOWED_TAGS: [
        'a',
        'div',
        'span',
        'p',
        'strong',
        'em',
        'ul',
        'ol',
        'li',
        'br',
      ],
      ALLOWED_ATTR: [
        'href',
        'target',
        'rel',
        'src',
        'alt',
        'title',
        'class',
        'style',
      ],
    });
  }

  return { copiarCodigoParaAreaDeTransferencia, higienizarHTML };
}
